videojs.addLanguage('ro', {
  "Audio Player": "Player audio",
  "Video Player": "Player video",
  "Play": "Piesă",
  "Pause": "Pauză",
  "Replay": "Reluare",
  "Current Time": "Ora curentă",
  "Duration": "Durată",
  "Remaining Time": "Timp rămas",
  "Stream Type": "Tip flux",
  "LIVE": "ÎN DIRECT",
  "Seek to live, currently behind live": "Căutare în direct; în prezent, sunteți în urmă",
  "Seek to live, currently playing live": "Căutare în direct; în prezent, se redă în direct",
  "Loaded": "Încărcat",
  "Progress": "Progres",
  "Progress Bar": "Bară de progres",
  "progress bar timing: currentTime={1} duration={2}": "{1} din {2}",
  "Fullscreen": "Ecran complet",
  "Non-Fullscreen": "Ecran parțial",
  "Mute": "Suprimare sunet",
  "Unmute": "Activare sunet",
  "Playback Rate": "Rată de redare",
  "Subtitles": "Subtitrări",
  "subtitles off": "subtitrări dezactivate",
  "Captions": "Indicații scrise",
  "captions off": "indicații scrise dezactivate",
  "Chapters": "Capitole",
  "Descriptions": "Descrieri",
  "descriptions off": "descrieri dezactivate",
  "Audio Track": "Pistă audio",
  "Volume Level": "Nivel volum",
  "You aborted the media playback": "Ați abandonat redarea media",
  "A network error caused the media download to fail part-way.": "O eroare de rețea a provocat eșecul descărcării conținutului media în timpul procesului.",
  "The media could not be loaded, either because the server or network failed or because the format is not supported.": "Conținutul media nu a putut fi încărcat, fie pentru că serverul sau rețeaua a eșuat, fie pentru că formatul nu este acceptat.",
  "The media playback was aborted due to a corruption problem or because the media used features your browser did not support.": "Redarea media a fost întreruptă din cauza conținutului corupt sau din cauza faptului că acest conținut media folosește funcții pe care browserul dvs. nu le acceptă.",
  "No compatible source was found for this media.": "Nu au fost găsite surse compatibile pentru acest conținut media.",
  "The media is encrypted and we do not have the keys to decrypt it.": "Conținutul media este criptată și nu avem cheile pentru decriptare.",
  "Play Video": "Redare video",
  "Close": "Închidere",
  "Close Modal Dialog": "Închidere dialog modal",
  "Modal Window": "Fereastră modală",
  "This is a modal window": "Aceasta este o fereastră modală",
  "This modal can be closed by pressing the Escape key or activating the close button.": "Această fereastră modală poate fi închisă cu tasta Escape sau butonul de închidere.",
  ", opens captions settings dialog": ", deschide dialogul de setări pentru indicații scrise",
  ", opens subtitles settings dialog": ", deschide dialogul de setări pentru subtitrări",
  ", opens descriptions settings dialog": ", deschide dialogul de setări pentru descrieri",
  ", selected": ", selectat",
  "captions settings": "setări indicații scrise",
  "subtitles settings": "setări subtitrări",
  "descriptions settings": "setări descrieri",
  "Text": "Text",
  "White": "Alb",
  "Black": "Negru",
  "Red": "Roșu",
  "Green": "Verde",
  "Blue": "Albastru",
  "Yellow": "Galben",
  "Magenta": "Magenta",
  "Cyan": "Cyan",
  "Background": "Fundal",
  "Window": "Fereastră",
  "Transparent": "Transparent",
  "Semi-Transparent": "Semitransparent",
  "Opaque": "Opac",
  "Font Size": "Mărime font",
  "Text Edge Style": "Stil margine text",
  "None": "Fără",
  "Raised": "Ridicat",
  "Depressed": "Apăsat",
  "Uniform": "Uniformă",
  "Dropshadow": "Umbră",
  "Font Family": "Familie fonturi",
  "Proportional Sans-Serif": "Sans-serif proporțional",
  "Monospace Sans-Serif": "Sans-serif monospațiu",
  "Proportional Serif": "Serif proporțional",
  "Monospace Serif": "Serif monospațiu",
  "Casual": "Informal",
  "Script": "Script",
  "Small Caps": "Majuscule mici",
  "Reset": "Resetare",
  "restore all settings to the default values": "readuceți toate setările la valorile implicite",
  "Done": "Terminat",
  "Caption Settings Dialog": "Dialog setări indicații scrise",
  "Beginning of dialog window. Escape will cancel and close the window.": "Începutul ferestrei de dialog. Tasta Escape va anula și va închide fereastra.",
  "End of dialog window.": "Sfârșitul ferestrei de dialog.",
  "{1} is loading.": "{1} se încarcă.",
  "Exit Picture-in-Picture": "Închidere imagine în imagine",
  "Picture-in-Picture": "Imagine în imagine"
});